import logo200Image from '../assets/img/logo/logo_2.png';
import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import Typography from '../components/Typography';
import axios from '../utils/posAxios';
import { MdCameraAlt, MdFace, MdDone, MdClear } from 'react-icons/md';
import Avatar from '../components/Avatar';
import userPlaceholder from '../assets/img/users/profile.jpg';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import { getPayment } from '../utils/dropdownlist';

class PosScheduleModForm extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      isEdit: false,
      slot_id: '',
      slotmod_id: '',
      date: '',
      max_slot: '',
    };
  }

  componentDidMount() {
    console.log(this.props.data);
    if (this.props.data.isEdit) {
      let data = this.props.data;
      let mod_data = this.props.data.mod.find(
        x => x.slotmod_id === this.props.data.selectedId,
      );
      console.log(mod_data);
      this.setState({
        isEdit: data.isEdit,
        slotmod_id: data.selectedId,
        date: mod_data.date,
        max_slot: mod_data.max_slot,
      });
    } else {
      this.setState({
        slot_id: this.props.data.selectedId,
      });
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;

    if (!this.state.isEdit) {
      this.createMod(user, comp, url);
    } else {
      this.editMod(user, comp, url);
    }
  };

  createMod(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      slot_id: this.state.slot_id,
      date: this.state.date,
      max_slot: this.state.max_slot,
      created_by: user.email,
    };

    axios
      .post(url + ':3001/v1/schedule/slots/mod/create', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'New mod added successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  editMod(user, comp, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      slotmod_id: this.state.slotmod_id,
      date: this.state.date,
      max_slot: this.state.max_slot,
      update_by: user.email,
    };

    axios
      .post(url + ':3001/v1/schedule/slots/mod/update', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'Mod updated successfully.',
          'success', //'error' post when return error
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>
          Schedule Mod
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label>Date</Label>
                <Input
                  type="date"
                  name="date"
                  value={this.state.date}
                  onChange={this.changeHandler}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label>Max Slot</Label>
                <Input
                  type="number"
                  name="max_slot"
                  value={this.state.max_slot}
                  onChange={this.changeHandler}
                  required
                />
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    );
  }
}

export const STATE_ADD = 'ADD';
export const STATE_EDIT = 'EDIT';
export default PosScheduleModForm;
